var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8094 20H9.21324C7.99623 20 7 19.0274 7 17.8116V15.7984C7 15.5157 7.22642 15.2895 7.50944 15.2895C7.79246 15.2895 8.01888 15.5157 8.01888 15.7984V17.8116C8.01888 18.4676 8.55663 18.9822 9.21322 18.9822H16.8094C17.466 18.9822 17.9811 18.4676 17.9811 17.8116V3.18841C17.9811 2.53243 17.466 2.01784 16.8094 2.01784H9.21322C8.55658 2.01784 8.01888 2.53243 8.01888 3.18841V5.16195C8.01888 5.44469 7.79246 5.67089 7.50944 5.67089C7.22642 5.67089 7 5.44469 7 5.16195V3.18841C7 1.9726 7.99623 1 9.21324 1H16.8094C18.0264 1 19 1.9726 19 3.18841V17.8116C19 19.0274 18.0264 20 16.8094 20Z",
    fill: "#E93C3C",
    stroke: "#E93C3C",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76482 14.8757C4.6856 14.9605 4.58776 15 4.48991 15C4.37342 15 4.25694 14.9379 4.17307 14.8249L1.15376 10.6109C1.06057 10.5148 1 10.3736 1 10.2154C1 10.046 1.06989 9.89346 1.17706 9.80308L4.19172 6.14828C4.3548 5.95057 4.62037 5.95057 4.78348 6.14828C4.9466 6.34599 4.94656 6.66795 4.78348 6.8657L2.43978 9.70707H11.5806C11.8136 9.70707 12 9.93302 12 10.2155C12 10.4979 11.8136 10.7239 11.5806 10.7239H2.34691L4.80244 14.1583C4.9562 14.3673 4.93722 14.6893 4.76482 14.8757Z",
    fill: "#E93C3C",
    stroke: "#E93C3C",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectIcon);
export default __webpack_public_path__ + "static/media/disconnect-icon.42543dc5158430360e48528aa836f8c0.svg";
export { ForwardRef as ReactComponent };